export default __webpack_public_path__ + "static/media/caret-down-green.dc40c25e.svg";